import styled from "@emotion/styled";
import { Editor, Button } from "../../../../ui-components";
import { useState, useContext, useRef } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiCall from "../../../../utils/apiCall";
import apiCallFormData from "../../../../utils/apiFormDataCall";
import { NotificationContext } from "../../../../providers/notification";
import JEditor from "jodit-react";

interface EditorProps {
  IsActive: boolean;
  Messages: string;
  RouteType: string;
  Id: number;
  RouteId: number;
}

const EditRoutePage = (props: EditorProps) => {
  const [content, set_content] = useState<any>(props.Messages || "");
  const { showNotification } = useContext(NotificationContext);
  const queryClient = useQueryClient();
  const editor = useRef<any>(null);

  const config = {
    readonly: false,
    height: 300,
  };

  const editRoutePageEditor = async (data: any) => {
    return await apiCallFormData().put(
      `/SetUp/UpdateRoutePageEditor?RouteId=${props.RouteId}`,
      data
    );
  };

  const editRouteMutation = useMutation(
    ["edit-route-page-editor"],
    editRoutePageEditor,
    { retry: 0 }
  );

  const editRoutePageEditorHandler = async () => {
    const payload = new FormData();
    payload.append("RouteType", props.RouteType);
    payload.append("Id", props.Id.toString());

    payload.append(
      "IsActive",
      props.IsActive ? true.toString() : false.toString()
    );
    payload.append("Messages", content);
    payload.append("RouteId", props.RouteId.toString());

    try {
      await editRouteMutation.mutateAsync(payload, {
        onSuccess: (data: any) => {
          showNotification({
            type: "success",
            message: data.Message || " Route Page Edited Successfully",
          });

          queryClient.refetchQueries(["get-all-routes-page-editor"]);
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };
  return (
    <Wrapper>
      <p>EDIT PAGE</p>
      {/* <Editor value={content} 
        			onBlur={(newContent: any) => { console.log(newContent);set_content(newContent)}} // preferred to use only this option to update the content for performance reasons
                    //onChange={(newContent: any) => {}}      
         /> */}
      <JEditor
        ref={editor}
        value={content}
        config={config}
        onBlur={(newContent: any) => {
          set_content(newContent);
        }}
        onChange={(newContent) => {}}
        //onChange={(e) => handleUpdate}
      />
      <div>
        <Button onClick={editRoutePageEditorHandler}>
          {editRouteMutation.isLoading ? "Saving..." : "Save Page"}
        </Button>
      </div>
    </Wrapper>
  );
};

export default EditRoutePage;
const Wrapper = styled.div`
  padding: 20px;
  & > div:last-of-type {
    margin-top: 30px;
  }
`;
